import { render } from "./InputSelect.vue?vue&type=template&id=522738e4"
import script from "./InputSelect.vue?vue&type=script&lang=js"
export * from "./InputSelect.vue?vue&type=script&lang=js"
script.render = render

export default script